// REACT
import React, { useContext, RefObject, useRef } from 'react'

// ESTILOS
import Styles from './Services.module.css'

// CONTEXTO
import MainContext from 'Context/MainContext'

// COMPONENTES
import ServicesSliders from './ServicesSliders'

const ServicesIntro: React.FC = () => {
	// STRINGS
	const { intro } = useContext(MainContext).lang.services

	// REFERENCIAS
	const introRef: RefObject<HTMLDivElement> = useRef(null)

	return (
		<section>
			<section className={`${Styles.page} ${Styles.pageTop} page`} ref={introRef}>
				<div className={Styles.header}>
					<h1 className={Styles.headerTitle}>{intro.title}</h1>
					<p className={Styles.headerText}>{intro.text}</p>
				</div>
				<ul className={Styles.list}>
					{intro.list.map((item: string, key: number) => (
						<li key={key} className={Styles.listItem}>
							{item}
						</li>
					))}
				</ul>
			</section>

			<ServicesSliders />
		</section>
	)
}

export default ServicesIntro
